module.exports = __webpack_public_path__ + "static/media/lakhi.4a479ab2.jpg";